module.exports = __webpack_public_path__ + "static/media/29.dc297f08.webp";